import { render, staticRenderFns } from "./SaleCollaborationPanel.vue?vue&type=template&id=2eaa7eff&scoped=true"
import script from "./SaleCollaborationPanel.vue?vue&type=script&lang=js"
export * from "./SaleCollaborationPanel.vue?vue&type=script&lang=js"
import style0 from "./SaleCollaborationPanel.vue?vue&type=style&index=0&id=2eaa7eff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa7eff",
  null
  
)

export default component.exports